import vm from '@/main'
import { ReturnBaseUrl } from '@/network/request'

// 旧版区域接口保持不变；请求必须结束，且旧服务器/账号的响应不能写入当前页面。
const regionPageDataRequest = regionId => {
  const token = vm.$store.state.token
  const server = ReturnBaseUrl()
  return vm.$request({
    method: 'post', url: '/home/findRegionPage',
    data: { token, regionId }
  }).then(res => {
    if (token !== vm.$store.state.token || server !== ReturnBaseUrl()) {
      const error = new Error('STALE_REGION_RESPONSE')
      error.stale = true
      throw error
    }
    if (!res.data || res.data.code != 0) {
      const message = (res.data && res.data.message) || '区域加载失败，请重试'
      vm.$showTipsToast(3, message)
      throw new Error(message)
    }
    return res.data.data
  })
}
export { regionPageDataRequest }
